// Importar todas las imágenes desde el archivo centralizado
import {
  Zitrobio,
  Bioproxina500mg as Biproxina500mg,
  Cebiodroxilo500mg as cefadroxilo,
  Biofixima400mg,
  DeslonilMt5mg as Deslonil5mg,
  DeslonilMt10mg as Deslonil10mg,
  CiclesonaT as Ciclesona,
  VentiduoPlus as Ventiduo,
  Chamber as ChamberA,
  Ambiodipina,
  Bioprolol,
  Carbiolol,
  BiodipinaLP as biodipinaImg,
  Hidrobiozida,
  Bionapril,
  Biotelmic as biotelmic,
  Biozartan,
  Olmebloc,
  Atorvastatin,
  Rosuvastatin,
  Metforbio,
  Glimebio,
  Quetiapine,
  Biotahistin,
  Fludisina,
  Bioflazacort,
  Biogavalina,
  Flubionazol,
  Biotamsul,
  Bioez,
  Pantobio,
  Biosulfil,
} from './productImages';

const descripcionProductos = {
  Zitrobio: {
    nombre: 'Zitrobio',
    principioActivo: 'Azitromicina',
    dosis: '200mg/5ml 15ml y 30ml 500mg',
    slogan: 'Eficacia comprobada. Macrólido moderno de amplio espectro.',

    Indicaciones: [
      'Infecciones causadas por gérmenes sensibles a la azitromicina. Infecciones genitales no complicadas causadas por Chlamydia tracho- matis.Infecciones genitales no complicadas causadas por Neisseria gonorrhoeae. Infecciones causadas por Mycobacterium avium complex (pacientes VIH posítivos). Tratamiento de la infección ocular causada por Chlamydia trachomatis (Tracoma).Tratamiento de la faringitis causada por Streptococcus pyogenes del grupo A.Tratamiento de la otitis media aguda.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: '200mg/5ml 15ml, 30ml 500mgx30',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia, ni durante la lactancia, a menos que el médico lo indique. El uso prolongado o indiscriminado de este producto puede ocasionar la aparición de gérmenes resistentes. No exceda la dosis prescrita ni interrumpa el tratamiento antes del tiempo previsto, aunque hayan desaparecido los síntomas de la infección.`,

    contraindicaciones: 'Alergia a los componentes de la fórmula',

    imagen: Zitrobio,
  },
  Biproxina: {
    nombre: 'Bioproxina 500mg',
    principioActivo: 'Ciprofloxacina',
    dosis: '500mg',
    slogan:
      'Confianza terapéutica en cada tratamiento. Alta penetración tisular y eficacia probada frente a patógenos clave',

    Indicaciones: [
      'La ciprofloxacina es un antibiótico fluoroquinolona con actividad bactericida. Está indicado para el tratamiento de infecciones causadas por gérmenes sensibles al ciprofloxacino, infecciones no complicadas del tracto respiratorio alto, infecciones no complicadas del tracto urinario bajo, tratamiento de la gonorrea, tratamiento de la diarrea del viajero. Prevención y tratamiento de infecciones postexposición vía inhalatoria a Bacillus anthracis (ántrax).',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 10 tabletas',

    advertencias: `Durante su uso evite la exposición al sol por el riesgo de fotosensibilización. El uso prolongado o indiscriminado de este producto puede ocasionar la aparición de gérmenes resistentes. No exceda la dosis prescrita ni interrumpa el tratamiento antes del tiempo previsto, aunque hayan desaparecido los síntomas de la infección.`,

    contraindicaciones:
      'Hipersensibilidad a los componentes de la fórmula y a otras fluoroquinolonas. En pacientes menores de 18 años, salvo en los casos de prevención y tratamiento de infecciones postexposición vía inhalatoria a Bacillus anthracis, infecciones causadas por Pseudomonas aeruginosa en pacientes con fibrosis quística e infecciones graves y complicadas del tracto urinario por Escherichia coli resistente a otros antibacterianos',

    imagen: Biproxina500mg,
  },
  Cebiodroxilo: {
    nombre: 'Cebiodroxilo 500mg',
    principioActivo: 'Cefadroxilo',
    dosis: '500mg',
    slogan:
      'Eficacia y seguridad. Confianza y primera línea, en infecciones de tejido blando.',

    Indicaciones: [
      'Antibiótico betalactámico del grupo de las cefalosporinas (de 1ra. generación), con actividad bactericida. Indicado en el tratamiento de infecciones causadas por gérmenes sensibles al cefadroxilo.',
      'Actúa inhibiendo la síntesis de la barrera de peptidoglicano de la pared celular bacteriana alunirse e inactivar a las enzimas involucradas en el proceso.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 10 tabletas',

    advertencias: `El uso prolongado o indiscriminado de este producto puede ocasionar la aparición de gérmenes resistentes. Suspenda el tratamiento e informe inmediatamente al médico si se presentan síntomas de alergia o diarrea intensa y persistente con náuseas, dolor abdominal y fiebre. No exceda la dosis prescrita ni interrumpa el tratamiento antes del tiempo previsto, aunque hayan desaparecido los síntomas de la infección.`,

    contraindicaciones:
      'Alergia a los componentes de la fórmula, a otras cefalosporinas o a la penicilina y sus derivados  ',

    imagen: cefadroxilo,
  },
  Biofixima: {
    nombre: 'Biofixima 400mg',
    principioActivo: 'Cefrixima',
    dosis: '400mg',
    slogan:
      'Avanza con eficacia. Cefalosporina oral de 3ra generación: con cobertura extendida.',

    Indicaciones: [
      'Antibiótico betalactámico del grupo de las cefalosporinas (de 3ra. generación), con actividad bactericida en infecciones causadas por gérmenes sensibles a la cefixima. Actúa inhibiendo la síntesis de barrera de peptidoglicano de la pared celular bacteriana al unirse e inactivar a las enzimas (proteínas fijadoras de penicilina) implicadas en el proceso.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 5 tabletas',

    advertencias: `El uso prolongado o indiscriminado de este producto puede ocasionar la aparición de gérmenes resistentes. Suspenda el tratamiento e informe inmediatamente al médico si se presentan síntomas de alergia o diarrea intensa y persistente con náuseas, dolor abdominal y fiebre. No exceda la dosis prescrita ni interrumpa el tratamiento antes del tiempo previsto, aunque hayan desaparecido los síntomas de la infección.`,

    contraindicaciones:
      'Alergia a los componentes de la fórmula, a otras cefalosporinas o a la penicilina y sus derivados',

    imagen: Biofixima400mg,
  },
  Deslonil5mg: {
    nombre: 'DeslonilMt',
    principioActivo: 'Desloratadina y Montelukast',
    dosis: '5mg',
    slogan:
      'Respira sin interrupciones.Alivio sintomático sin causar somnolencia.',

    Indicaciones: [
      'Es un antagonista selectivo de receptores de histamina H1 periféricos, de acción prolongada, no sedante, antialérgico. Indicado para el alivio de síntomas asociados a rinitis alérgica y asma concomitante.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Este producto no debe administrarse en el manejo de las crisis agudas de asma. Producto de uso delicado que debe ser administrado bajo vigilancia médica. No exceda la dosis prescrita.`,

    contraindicaciones: 'Alergia a los componentes de la fórmula.',

    imagen: Deslonil5mg,
  },
  Deslonil10mg: {
    nombre: 'DeslonilMt 10mg',
    principioActivo: 'Desloratadina y Montelukast ',
    dosis: '10mg',
    slogan:
      'Respira sin interrupciones.Alivio sintomático sin causar somnolencia.',

    Indicaciones: [
      'Es un Antagonista selectivo de receptores de histamina H1 periféricos, de acción prolongada, no sedante, antialérgico. Indicado para el alivio de síntomas asociados a rinitis alérgica y asma concomitante.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Este producto no debe administrarse en el manejo de las crisis agudas de asma. Producto de uso delicado que debe ser administrado bajo vigilancia médica. No exceda la dosis prescrita.`,

    contraindicaciones: 'Alergia a los componentes de la fórmula.',

    imagen: Deslonil10mg,
  },
  Ambiodipina: {
    nombre: 'Ambiodipina',
    principioActivo: 'Amlodipina ',
    dosis: '10mg y 5mg',
    slogan:
      'Control que se mantiene. Reducción eficaz del LDL y prevención cardiovascular primaria y secundaria.',

    Indicaciones: [
      'Tratamiento de hipertensión arterial y ángor pectoris. Coadyuvante en el tratamiento de la insuficiencia cardíaca crónica severa. Tratamiento de la angina vasoespástica (Prinzmetal) ',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento. No exceda la dosis prescrita.`,

    precauciones: 'En conductores de vehículos y uso de maquinarias',
    contraindicaciones:
      'Alergia a los componentes de la fórmula. Hipertensión grave. Shock (incluyendo shock cardiogénico). Obstrucción del conducto arterial del ventrículo izquierdo. Embarazo.',

    imagen: Ambiodipina,
  },

  Bioprolol25: {
    nombre: 'Bioprolol',
    principioActivo: 'Bisoprolol Fumarato',
    dosis: '2.5mg y 5mg',
    slogan:
      'Control con precisión, bienestar con confianza. Eficacia cardiovascular con selectividad y tolerancia superior.',

    Indicaciones: [
      'Tratamiento de la hipertensión arterial. Tratamiento de la cardiopatía isquémica crónica. Tratamiento de la insuficiencia cardíaca congestiva.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia ni durante la lactancia.  De ser imprescindible su uso por no existir otra alternativa terapéutica, suspéndase definitivamente la lactancia materna. No exceda la dosis prescrita. `,

    precauciones:
      'Realizar control periódico de la función renal, hepática, niveles de electrolitos y ácido úrico. Pacientes en tratamiento con hipoglicemiantes orales o insulina.  En pacientes con hipertensión o angina de pecho acompañada de insuficiencia cardíaca.',
    contraindicaciones:
      'Hipersensibilidad al Bisoprolol o a cualquiera de los componentes de la fórmula. – Administración concomitante con fármacos que depleten los depósitos de catecolaminas (Ej. Reserpina) o los inhibidores de la monoamino-oxidasa. - No se administre durante el embarazo o cuando se sospeche su existencia. - Insuficiencia cardíaca aguda o durante episodios de descompensación de la insuficiencia cardíaca, que requieran de tratamiento inotrópico intravenoso.  - Shock cardiogénico - Insuficiencia hepática grave.  ',

    imagen: Bioprolol,
  },

  chamber: {
    nombre: 'Chambers',
    principioActivo: '',
    dosis: '',
    slogan:
      'Tranquilidad que apoya cada respiro. Cuando cuesta inhalar, Chamber lo hace facil.',

    Indicaciones: ['Asma. EPOC. Bronquitis. Broncodilatadores. Post COVID'],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: '',

    advertencias: `Este producto no debe administrarse en el manejo de las crisis agudas de asma. Producto de uso delicado que debe ser administrado bajo vigilancia médica. No exceda la dosis prescrita.`,

      contraindicaciones: 'Alergia a los componentes de la fórmula',

    imagen: ChamberA,
  },

  Carbiolol: {
    nombre: 'Carbiolol',
    principioActivo: 'Carvedilol ',
    dosis: '6,25mg y 25mg',
    slogan:
      'Ritmo estable, presión controlada. Betabloqueante de referencia para hipertensión e insuficiencia cardíaca.',

    Indicaciones: [
      'Tratamiento coadyuvante de la insuficiencia cardíaca congestiva grado II y III. Tratamiento de la hipertensión arterial leve a moderada. Tratamiento a largo plazo de la angina de pecho estable e inestable.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia a menos que el médico lo indique. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspéndase la lactancia mientras dure el tratamiento. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Hipersensibilidad al fármaco o a otro componente de la fórmula. Bloqueo cardíaco de 2do y 3er grado. Insuficiencia cardíaca inestable/descompensada. Insuficiencia cardíaca de clase IV según la New York Heart Association (NYHA) que precise uso de inotrópicos intravenosos. Bloqueo A-V de segundo y tercer grado (excepto si se coloca un marcapasos de forma permanente).',

    imagen: Carbiolol,
  },

  BiodipinaLP: {
    nombre: 'BiodipinaLP',
    principioActivo: 'Nifedipina LP ',
    dosis: '30mg',
    slogan:
      'La presión no espera Biodipina LP actúa. Tu aliado para el tratamiento de la hipertensión y la angina de pecho crónica estable. ',

    Indicaciones: [
      'Tratamiento de la angina de pecho crónica estable. Tratamiento de la hipertensión arterial.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento.`,
    contraindicaciones:
      'Hipersensibilidad a la Nifedipina o a otro componente de la fórmula. Shock cardiogénico. Angina inestable infarto de miocardio reciente (últimas 4 semanas).',

    imagen: biodipinaImg,
  },
  Hidrobiozida: {
    nombre: 'Hidrobiozida',
    principioActivo: 'Hidroclorotiazida ',
    dosis: '12,5mg',
    slogan:
      'El equilibrio que tu salud necesita. Eficacia diurética para una presión estable.',

    Indicaciones: [
      'Tratamiento de la Hipertensión arterial. Tratamiento del Edema.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento. Este producto no debe ser utilizado como terapia de alivio de los síntomas agudos de la EPOC.  Si con el uso de este medicamento se produce empeoramiento agudo de los síntomas, suspéndase su uso y consulte inmediatamente al médico.`,
    contraindicaciones: 'Alergia a los componentes de la fórmula.',

    imagen: Hidrobiozida,
  },
  Bionapril: {
    nombre: 'Bionapril',
    principioActivo: 'Enalapril ',
    dosis: '5mg y 10mg',
    slogan:
      'Doble protección en una toma. Primera opción en el control de la hipertensión y protección renal.',

    Indicaciones: [
      'Hipertensión Arterial. Insuficiencia cardíaca congestiva grado III y IV. Hipertensión renovascular unilateral. Prevención de la dilatación y disfunción ventricular progresiva en pacientes postinfartados.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento.`,
    contraindicaciones:
      'Alergia a los componentes de la fórmula. Embarazo y lactancia: En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento.',

    imagen: Bionapril,
  },

  biotelmic: {
    nombre: 'Biotelmic',
    principioActivo: 'Telmisartan ',
    dosis: '40mg y 80mg',
    slogan:
      'Control total cardiometabólico. ARA II con efecto metabólico. Cardioprotección perfil hepático favorable.',

    Indicaciones: ['Tratamiento de la hipertensión arterial.'],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado, que debe ser administrado bajo estricta vigilancia médica. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspéndase la lactancia mientras dure el tratamiento.  No exceda la dosis prescrita.`,
    contraindicaciones:
      'Alergia a los componentes de la fórmula. Patología biliar obstructiva.  Insuficiencia renal y hepática severa. Embarazo.',

    imagen: biotelmic,
  },
  Biozartan: {
    nombre: 'Biozartan',
    principioActivo: 'Losartán Potasico ',
    dosis: '50mg',
    slogan:
      'Confianza en cada latido. Control efectivo y seguro de la presión arterial.',

    Indicaciones: [
      'Tratamiento de la hipertensión arterial. Tratamiento de la insuficiencia cardíaca moderada a severa. Reducción del riesgo de morbilidad y mortalidad cardiovascular en pacientes hipertensos con hipertrofia ventricular izquierda. Protección renal en pacientes con diabetes tipo II con proteinuria.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica.  En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspenda la lactancia materna mientras dure el tratamiento. No exceda la dosis prescrita. `,
    contraindicaciones:
      'Alergia a los componentes de la fórmula. Insuficiencia hepática grave. No se administre durante el embarazo o cuando se sospeche su existencia.',

    imagen: Biozartan,
  },
  Olmebloc: {
    nombre: 'Olmebloc',
    principioActivo: 'Olmersartan ',
    dosis: '20mg y 40mg',
    slogan:
      'Precisión que protege. Potencia antihipertensiva con seguridad renal.',

    Indicaciones: ['Tratamiento de la hipertensión arterial.'],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo vigilancia médica. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspenda la lactancia materna mientras dure el tratamiento. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Alergia a los componentes de la fórmula.  Embarazo. Insuficiencia renal severa (depuración de creatinina < 20 mL/min). Insuficiencia hepática severa y obstrucción biliar.',

    imagen: Olmebloc,
  },

  Quetiapine50: {
    nombre: 'Quetiapine',
    principioActivo: 'Quetiapina ',
    dosis: '50mg y 100mg',
    slogan:
      'Estabilidad y mente en calma. Manejo confiable de trastornos psiquiátricos.',

    Indicaciones: [
      'Prevención de la recurrencia del trastorno bipolar (episodio maníaco, mixto o depresivo) como monoterapia o en combinación con estabilizadores del humor.  Tratamiento de episodio depresivo asociado con el trastorno bipolar. Tratamiento de la esquizofrenia.  Monoterapia y terapia adyuvante en la manía aguda con trastorno bipolar.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia, ni durante la lactancia, a menos que el médico lo indique.  Este producto puede causar somnolencia, durante su administración evite actividades que impliquen coordinación y estado de alerta mental.  No suspenda este producto sin la indicación de su médico tratante. Con el uso de este producto no ingiera bebidas alcohólicas. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Alergia a los componentes de la fórmula. Menores de 18 años. Coadministración con inhibidores del citocromo P-450 3A4, tales como inhibidores de las proteasas del VIH, agentes antifúngicos de tipo azol, eritromicina, claritromicina y nefazodona.',

    imagen: Quetiapine,
  },

  Biotahistin: {
    nombre: 'Biotahistin',
    principioActivo: 'Betahistina ',
    dosis: '8mg',
    slogan:
      'Más estabilidad, Menos vértigo. Control del vértigo en síndrome de Méniere con acción central e inmediata.',

    Indicaciones: ['Tratamiento sintomático de la enfermedad de Meniére. '],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia, a menos que el médico lo indique.  En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento.  El paciente debe informar al médico de cualquier efecto indeseable, especialmente del tracto digestivo.  No exceda la dosis prescrita. Con el uso de este producto no ingiera bebidas alcohólicas, ni sedantes. `,
    contraindicaciones:
      'Hipersensibilidad a la betahistina o cualquier componente de la fórmula. Sangramiento gastroduodenal y/o úlcera gastroduodenal activa, asma bronquial aguda. Feocromocitoma',

    imagen: Biotahistin,
  },
  Fludisina: {
    nombre: 'Fludisina',
    principioActivo: 'Flunarazina ',
    dosis: '10mg',
    slogan:
      'Tu aliado contra las migrañas. Prevención efectiva de migrañas con efecto vasodilatador cerebral.',

    Indicaciones: [
      'Tratamiento de afecciones vestibulares, como síndrome de Meniere. Tratamiento de afecciones vasculares periféricas. Tratamiento profiláctico de la migraña.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica.  No se administre durante el embarazo o cuando se sospeche su existencia, a menos que el médico lo indique. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspenda la lactancia mientras dure el tratamiento. Este producto puede causar somnolencia. Durante su administración evítense actividades que impliquen coordinación y estado de alerta mental. Con el uso de este producto no ingiera bebidas alcohólicas.  No exceda la dosis prescrita.`,
    contraindicaciones:
      'Hipersensibilidad a los componentes de la fórmula. Pacientes con síndrome depresivo o antecedentes de depresión recurrente. Parkinsonismo u otros trastornos extrapiramidales.',

    imagen: Fludisina,
  },
  CiclesonaT: {
    nombre: 'Ciclesona-T',
    principioActivo:
      'Inhalador de 120 dosis medidas. Inhalador de Ciclesonida 200mcg. Fumarato de Formoterol 6mcg y Bromuro de Tiotropio 9mcg',
    dosis: '',
    slogan:
      'Innvación que cuentas Controla cada dosis, respira sin preocupaciones',

    Indicaciones: [
      'Tratamiento regular a largo plazo de la obstrucción reversible de las vías respiratorias. Tratamiento regular de la enfermedad pulmonar obstructiva crónica, incluyendo bronquitis y enfisema.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Inhalador de 120 dosis',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento.  Si con el uso de este medicamento se produce empeoramiento agudo de los síntomas, suspéndase su uso y consulte inmediatamente al médico. No exceda la dosis prescrita.`,
    contraindicaciones: 'Alergia a los componentes de la fórmula.',

    imagen: Ciclesona,
  },
  Ventiduo: {
    nombre: 'Ventiduo-Plus',
    principioActivo:
      'Propionato de Fluticasona 250mcg y Xinafoato de Salmeteroll 25mcg',
    dosis: '',
    slogan:
      'Fórmula Dual Control total Doble acción. mayor eficacia para una mejor respiración.',

    Indicaciones: ['Indicado para casos de asma y bronquitis.'],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Inhalador de 120 dosis medidas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica.    No se administre durante el embarazo o cuando se sospeche su existencia, ni durante la lactancia, a menos que el médico lo indique.  No exceda la dosis prescrita, ni suspenda o interrumpa el tratamiento sin el consentimiento del médico.`,
    contraindicaciones:
      'Alergia a los componentes de la fórmula. Niños menores de 4 años.',

    imagen: Ventiduo,
  },

  Bioflazacort: {
    nombre: 'Bioflazacort',
    principioActivo: 'Deflazacort',
    dosis: '6mg y 30mg',
    slogan:
      'Efecto corticoide, cuidado total. Terapia prolongada, riesgo controlado.',

    Indicaciones: [
      'Tratamiento de enfermedades inflamatorias que responden a la terapia esteroidea.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia, a menos que el médico lo indique. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspenda la lactancia materna mientras dure el tratamiento. No exceda la dosis prescrita ni interrumpa el tratamiento sin el conocimiento del médico.`,
    contraindicaciones:
      'Hipersensibilidad al deflazacort o a los componentes de la fórmula. Pacientes con infecciones bacterianas, virales o micóticas. Previo o posterior a vacunación.',

    imagen: Bioflazacort,
  },

  Biogavalina: {
    nombre: 'Biogavalina',
    principioActivo: 'Pregabalina',
    dosis: '75mg y 150mg',
    slogan:
      'Equilibra tu sistema, mejora tu bienestar.Alivio eficaz del dolor neuropático, con excelente tolerancia. ',

    Indicaciones: [
      'Tratamiento anticonvulsivante en aquellos pacientes refractarios a otros tratamientos anticonvulsivantes. Tratamiento del dolor neuropático en pacientes refractarios al tratamiento de base. Tratamiento de la fibromialgia.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspéndase la lactancia mientras dure el tratamiento. Este producto puede causar somnolencia, durante su administración evite actividades que impliquen coordinación y estado de alerta mental. No suspenda este producto sin la indicación de su médico tratante. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Alergia a los componentes de la fórmula. No se administre durante el embarazo o cuando se sospeche su existencia.',

    imagen: Biogavalina,
  },
  Atorvastatin: {
    nombre: 'Atorvastatin',
    principioActivo: 'Atorvastatina ',
    dosis: '20mg y 40mg',
    slogan:
      'Tu colesterol bajo control. Reducción eficaz del LDL y prevención cardiovascular primaria y secundaria.',

    Indicaciones: [
      'Tratamiento del hipercolesterolemia primario, hiperlipidemia combinada (mixta) e hipercolesterolemia familiar heterocigota y homocigota. Prevención de eventos isquémicos recurrentes en pacientes con dislipidemias y enfermedad coronaria.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo vigilancia médica. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Hipersensibilidad a la atorvastatina o a otros componentes de la fórmula. No se administre durante el embarazo o cuando se sospeche su existencia. Pacientes con disfunción o insuficiencia hepática activa o con elevaciones injustificadas y persistentes de los niveles de transaminasas plasmáticas que superen tres veces el valor máximo de normalidad.  Niños menores de 10 años.',

    imagen: Atorvastatin,
  },

  Rosuvastatin: {
    nombre: 'Rosuvastatin',
    principioActivo: 'Rosuvastatin ',
    dosis: '20mg y 40mg',
    slogan: 'Cuida tu latir. Protección cardiovascular comprobada',

    Indicaciones: [
      'Hipercolesterolemia primaria,  familiar homocigota y heterocigota, hiperlipidemia combinada (mixta). Reducción de la progresión de la ateroesclerosis en pacientes con alto riesgo cardiovascular. Prevención de eventos cardiovasculares.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspéndase la lactancia mientras dure el tratamiento. No suspenda el medicamento sin la indicación del médico tratante. No exceda la dosis prescrita`,
    contraindicaciones:
      'Hipersensibilidad a los componentes de la formula. Pacientes con enfermedad hepática activa, Pacientes con insuficiencia renal grave. Menores de 18 años. Embarazo.',

    imagen: Rosuvastatin,
  },

  Flubionazol: {
    nombre: 'Flubionazol',
    principioActivo: 'Fluconazol ',
    dosis: '150mg',
    slogan:
      'Potencia y seguridad. Antifúngico de amplio espectro, con excelente biodisponibilidad oral.',

    Indicaciones: [
      'Micosis profundas. Candidiasis vaginal. Candidiasis orofaríngea y esofágica en pacientes inmunocomprometidos. Micosis dérmicas (tiñia corporis, tiña cruris o tiña pedis).Onicomicosis por dermatofitos. Infecciones sistémicas graves por Candida, incluyendo infecciones del tracto urinario, peritonitis y neumonía.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 2 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No se administre durante el embarazo o cuando se sospeche su existencia a menos que el médico lo indique. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspéndase la lactancia mientras dure el tratamiento. No interrumpa el tratamiento antes del tiempo previsto, aunque hayan desaparecido los síntomas de la infección. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Alergia a los componentes de la fórmula. Insuficiencia hepática. Hipersensibilidad al fluconazol, a otros azoles o a los excipientes de la fórmula. Insuficiencia hepática. Coadministración con terfenadina, cisaprida, astemizol, pimozida, quinidina y eritromicina.',

    imagen: Flubionazol,
  },
  Biotamsul: {
    nombre: 'Biotamsul',
    principioActivo: 'Tamsolusina ',
    dosis: '0.4mg',
    slogan:
      'Alivio que fluye. Tratamiento para HBP, con selectividad alfa-1a y mínimo impacto sistémico.',

    Indicaciones: [
      'Tratamiento de la hiperplasia prostática benigna en casos en los que la cirugía no está indicada',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. No exceda la dosis prescrita`,
    contraindicaciones:
      'Hipersensibilidad a la tamsulosina o a los excipientes de la fórmula. Insuficiencia hepática sevora.',

    imagen: Biotamsul,
  },
  Metforbio: {
    nombre: 'Metforbio',
    principioActivo: 'Metformina ',
    dosis: '500mg y 1000mg',
    slogan:
      'Estabilidad glucémica con respaldo. Primera elección en diabetes tipo 2, con bajo riesgo de hipoglucemia y efecto metabólico.',

    Indicaciones: [
      'Diabetes melitus tipo 2 en especial en pacientes con sobrepeso. En adultos, en monoterapia o asociada con otros antidiabéticos orales, a con insulina. En niños mayores a 10 años y adolescentes en monoterapia o en combinación con insulina.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento. En caso de presentar temblor, sudoración, visión borrosa y debilidad, suspenda el producto y consulte al médico. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Alergia a los componentes de la formula. No se raministre durante el embarazo o cuando se sospeche su existencia',

    imagen: Metforbio,
  },

  Glimebio: {
    nombre: 'Glimebio',
    principioActivo: 'Glimepiride ',
    dosis: '2mg y 4mg',
    slogan:
      'Control sostenido. Confianza diaria. Sulfonilurea de nueva generación, eficaz y segura como monoterapia o combinada',

    Indicaciones: [
      'Tratamiento de la Diabetes mellitus tipo 2. En asociación con metformina, en pacientes con diabetes Mellitus 2.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo estricta vigilancia médica. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica suspéndase la lactancia mientras dure el tratamiento. No es sustituto de la insulina ni puede ser empleado en todas las formas de diabetes. Su empleo no excluye el régimen dietético, ni los demás controles indicados por el médico. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Hipersensibilidad a la glimepirida, otras sulfonilureas o sulfonamidas o a alguno de los excipientes. Acidosis de cualquier etiología, discrasias sanguíneas, ictericia (previa o actual). Diabetes insulino dependiente, coma diabético, cetoacidosis. Alteraciones graves de la función renal o hepática.',

    imagen: Glimebio,
  },
  Bioez: {
    nombre: 'Bioez',
    principioActivo: 'Ezomeprazol ',
    dosis: '20mg y 40mg',
    slogan:
      'Cada dosis con el efecto que esperas. Control sostenido del ácido gástrico. Ideal para ERGE, úlceras y terapias combinadas',

    Indicaciones: [
      'Tratamiento de la enfermedad por reflujo gastroesofágico. Prevención de úlceras gastroduodenales. Tratamiento de úlcera gástrica inducida por AINEs.',
      'En combinación con antibióticos en el tratamiento de la úlcera duodenal causada por Helicobacter pylori. Tratamiento de síndrome de Zollinger-Elison e hipersecreción de ácido gástrico.',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo vigilancia médica No se administre durante el embarazo O cuando se sospeche SU existencia, ni durante lactancia menos que el médico indique No exced: dosis prescrita.`,
    contraindicaciones: 'Alergia a los componentes de la fórmula',

    imagen: Bioez,
  },

  Pantobio: {
    nombre: 'Pantobio',
    principioActivo: 'Pantoprazol ',
    dosis: '40mg',
    slogan:
      'Alivio más allá de la acidez. Inhibidor confiable para el tratamiento integral de enfermedades ácido-dependientes.',

    Indicaciones: [
      'Tratamiento de la úlcera duodenal, úlcera gástrica, reflujo gastroesofágico, esofagitis por reflujo y síndrome de Zollinger-Ellison',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Caja x 30 tabletas',

    advertencias: `Producto de uso delicado que debe ser administrado bajo vigilancia médica No se administre durante el embarazo O cuando se sospeche SU existencia, ni durante lactancia menos que el médico indique No exced: dosis prescrita.`,
    contraindicaciones: 'Alergia a los componentes de la fórmula',

    imagen: Pantobio,
  },
  Biosulfil: {
    nombre: 'Biosulfil',
    principioActivo: 'Sulfadiazina de plata',
    dosis: '',
    slogan:
      'Alivio que fluye. Tratamiento para HBP, con selectividad alfa-1a y mínimo impacto sistémico.',

    Indicaciones: [
      'Prevención y tratamiento de las infecciones de las quemaduras de segundo y tercer grado',
    ],

    posología: 'A juicio del facultativo.',

    regulación: {
      titulo: 'Regulación de venta:',
      contenido: 'Con prescripción facultativa y récipe archivado',
    },

    cajaInfo: 'Crema 30gr',

    advertencias: `Producto de uso delicado que debe ser administrado bajo vigilancia médica. No se administre en neonatos prematuros, ni durante el embarazo o cuando se sospeche su existencia, a menos que el médico lo indique. En caso de ser imprescindible su uso por no existir otra alternativa terapéutica, suspenda la lactancia materna mientras dure el tratamiento. Al aplicar el producto evite el contacto con los ojos. El uso prolongado puede favorecer la aparición de hongos en el área afectada. Si durante el uso de este producto se presentan reacciones climatológicas inusuales u otros síntomas de alergias, suspenda el tratamiento e informe al médico. No exceda la dosis prescrita.`,
    contraindicaciones:
      'Hipersensibilidad a los componentes de la formulación. Durante las últimas semanas del embarazo. Recién nacidos prematuros o menores de 2 meses',

    imagen: Biosulfil,
  },
};

export default descripcionProductos;
